import type { Dispatch, SetStateAction } from 'react';

import { hasValue } from 'utils/hasValue';

import { Badge } from '@atoms/badges/Badge/Badge';

import type { PAYOUTS_KNOWN_SECTIONS } from './PayoutDetails';

type Props = {
  attributeErrors: string[];
  activeSection?: PAYOUTS_KNOWN_SECTIONS;
  setActiveSection?: Dispatch<SetStateAction<PAYOUTS_KNOWN_SECTIONS>>;
};

export const ErrorBadge = ({
  attributeErrors,
  activeSection,
  setActiveSection
}: Props) => {
  if (!hasValue(attributeErrors) || attributeErrors.length === 0) {
    return null;
  }

  return (
    <div className="error-badges my-[3px] flex flex-wrap gap-[3px]">
      {attributeErrors.map((error, index) => (
        <Badge
          onClick={(e) => {
            if (!setActiveSection || activeSection === 'summary') {
              return;
            }
            e.stopPropagation();
            setActiveSection('summary');
          }}
          key={index}
          label={error}
          className={`bg-feedback-error-surface ${error ? 'cursor-pointer' : ''}`}
        />
      ))}
    </div>
  );
};
